import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Search, UserX } from "lucide-react";
import { Input } from "@/components/ui/input";
import { PageHeader } from "@/components/PageHeader";
import { api, errMsg, fmtDate, showPin } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { RemovedActions } from "@/components/member-accounts/RemovedActions";

const Card = ({ m, canAct, onDone }) => (
  <div className="bg-white border border-[#E5E7EB] rounded-lg p-4" data-testid={`removed-member-${m.id}`}>
    <div className="flex flex-wrap items-start gap-3">
      <div className="w-10 h-10 rounded-md grid place-items-center bg-[#FFF0F0] text-[#E60000]"><UserX className="w-5 h-5" /></div>
      <div className="flex-1 min-w-0">
        <div className="font-heading font-bold" data-testid={`removed-member-name-${m.id}`}>{m.name}</div>
        <div className="text-xs text-gray-500">{m.email} · AHPC {showPin(m.pin) || "—"} · GAMLS {m.gamls_id || "—"} · Staff {m.staff_id || "—"}{m.phone ? ` · ${m.phone}` : ""}</div>
        <div className="text-xs text-gray-500">Joined {fmtDate(m.created_at)}</div>
      </div>
      <div className="text-right text-xs">
        <div className="font-semibold" data-testid={`removed-member-by-${m.id}`}>Removed by {m.removed_by || "Staff"}</div>
        <div className="text-gray-500">{fmtDate(m.removed_at)}</div>
      </div>
    </div>
    <div className="mt-3 border-t pt-2 text-sm" data-testid={`removed-member-reason-${m.id}`}><span className="text-xs font-bold uppercase tracking-wider text-gray-500 mr-2">Reason</span>{m.removal_reason}</div>
    {canAct && <div className="mt-3 flex justify-end"><RemovedActions m={m} onDone={onDone} /></div>}
  </div>
);

export default function RemovedAccounts() {
  const [q, setQ] = useState("");
  const [list, setList] = useState(null);
  const [tick, setTick] = useState(0);
  const { role } = useApp();
  useEffect(() => {
    const t = setTimeout(() => api.get("/removed-members", { params: { q } }).then((r) => setList(r.data)).catch((e) => toast.error(errMsg(e))), 250);
    return () => clearTimeout(t);
  }, [q, tick]);
  return (
    <div data-testid="removed-accounts-page">
      <PageHeader eyebrow="Control" title="Removed Member Accounts" description="Member logins removed by the Super Admin, with who removed them, when and why. Their registrations, payments and receipts are kept." />
      <div className="relative max-w-md mb-4"><Search className="w-4 h-4 absolute left-3 top-3 text-gray-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, email, ID, remover or reason" className="pl-9 h-10 bg-white" data-testid="removed-accounts-search" /></div>
      {!list ? <div className="text-gray-500">Loading…</div> : <div className="space-y-3">
        {list.map((m) => <Card key={`${m.id}-${m.removed_at}`} m={m} canAct={role === "Super Admin"} onDone={() => setTick((x) => x + 1)} />)}
        {!list.length && <div className="p-10 text-center text-sm text-gray-500 bg-white border rounded-lg" data-testid="removed-accounts-empty">{q ? "No removed accounts match your search." : "No member accounts have been removed."}</div>}
      </div>}
    </div>
  );
}
